import React from 'react';
import PropTypes from 'prop-types';

import GlobeLogo from './svg/GlobeLogo';
import GlobeLogoSmall from './svg/GlobeLogoSmall';
import Facebook from './svg/Facebook';
import Mail from './svg/Mail';
import Twitter from './svg/Twitter'

import '../css/header.css';

class BaseHeader extends React.Component {
  static propTypes = {
    sectionURL: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    section: PropTypes.string,
  }

  createMailLink = (title, url) => {
    return `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(title)}%0A%0A${url}`
  }

  createFacebookLink = (url) => {
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(url)}`
  }

  createTwitterLink = (title, url) => {
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&via=BostonGlobe&url=${encodeURI(url)}`
  }

  render () {
    return (
      <header className='g-header'>
        <div className='g-header__inner'>
          <div className="g-header__logo">
            <a href='http://www.bostonglobe.com'>
              <GlobeLogo />
              <GlobeLogoSmall />
            </a>
          </div>
          <nav className='g-header__title benton-bold'>
            <a href={this.props.sectionURL}>{this.props.section}</a>
          </nav>
          <div className='g-header__share'>
            <a href={this.createMailLink(this.props.title, this.props.url)} className='g-header__share-button g-header__share-button--ma'>
              <Mail />
            </a>
            <a href={this.createFacebookLink(this.props.url)} className='g-header__share-button g-header__share-button--fb'>
              <Facebook />
            </a>
            <a href={this.createTwitterLink(this.props.title, this.props.url)} className='g-header__share-button g-header__share-button--tw'>
              <Twitter />
            </a>
          </div>
        </div>
      </header>
    )
  }
}

export default BaseHeader;